import { Button, Empty, Pagination, PaginationProps } from 'antd';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import HeroSection from '@/components/V2/HomePage/HeroSection';

import MyOrderCard from './MyOrderCard';
import { ShouldRender } from '../shared/basic/ShouldRender';
import { formateErrorObject } from '../shared/formateErrorObject';
import CustomLoader from '../shared/Loading';
import { notify } from '../shared/notify';
import { getAllInAppOrdersList, getAllOrdersList } from '../../services/Orders';
import {
  FormattedOrder,
  PaginationProps as PaginationProp,
} from '../../utils/interfaces/Orders';

type Tab = 'App Orders' | 'Web Orders';

const MyOrders = () => {
  const [orderData, setOrderData] = useState<FormattedOrder[]>([]);
  const [inAppPurchaseData, setInAppPurchaseData] = useState<FormattedOrder[]>(
    [],
  );

  const [paginationData, setPaginationData] = useState<PaginationProp>();
  const [page, setPage] = useState<number>(1);
  const [fetchOrders, setFetchOrders] = useState(false);
  const [loading, setLoading] = useState(false);

  const [activeTab, setActiveTab] = useState<Tab>('Web Orders');


  const router = useRouter();

  const handleTabSwitch = (tab: Tab) => {
    setActiveTab(tab);

    if (tab === 'Web Orders') {
      router.push('/my-orders/');
    } else if (tab === 'App Orders') {
      router.push('/in-app-orders');
    }
  };
  const getAllOrders = async (page?: number) => {
    try {
      setLoading(true);
      const data = await getAllOrdersList(page);
      const result = data?.data;

      if (result) {
        setOrderData(
          result.map((order: any) => ({
            orderId: order.id,
            orderDate: order.date,
            paymentType: order?.payment_type,
            grand_total: order.grand_total,
            rzp_order_id: order?.payment_details?.rzp_order_id || 0,
            payment_status: order.payment_status,
            delivery_status: order?.delivery_status,
            order_cancel_request: order?.order_cancel_request !== null,
            payment_details: order?.payment_details,
            currency_code: order?.currency_code,
            shipping_address: order?.shipping_address,
            shipping_details: order?.shipping_details,
            list: order.orderDetails.map((orderDetail: any) => ({
              image: orderDetail.product.thumbnail_image,
              name: orderDetail.product.name,
              price: orderDetail.discounted_price,
              actualPrice: orderDetail.product.stroked_price,
              type: orderDetail.product.book_type,
              quantity: orderDetail.quantity,
              statusDate: '',
              status: order.delivery_status_string,
              is_preorder: orderDetail.product.is_preorder,
              category: orderDetail.product?.book_type,
              itemType: orderDetail?.product?.category,
              i18n_attributes: orderDetail?.product?.i18n_attributes,
              currency_symbol: order.currency_symbol || '₹',
              digital_pair: orderDetail?.product?.digital_pair,
            })),
          })),
        );
        setPaginationData({
          current_page: data?.meta?.current_page,
          per_page: data?.meta?.per_page,
          total: data?.meta?.total,
        });
      }
    } catch (error: any) {
      const message =
        formateErrorObject(error) || 'An error occurred while fetching data.';

      notify(message, 'error');
    } finally {
      setLoading(false);
    }
  };

  const getAllInAppOrders = async (page?: number) => {
    try {
      setLoading(true);
      const data = await getAllInAppOrdersList(page);
      const result = data?.data;

      if (result) {
        setInAppPurchaseData(
          result.map((order: any) => ({
            orderId: order.order_id,
            orderDate: order.purchase_date,
            paymentType: order?.payment_type,
            payment_status: order.order_status,
            delivery_status: order?.delivery_status,
            list: [
              {
                image: order.product.thumbnail_image,
                name: order.product.name,
                price: order.product.main_price,
                actualPrice: order.product.stroked_price,
                quantity: 1,
                type: order.product.book_type,
                statusDate: '',
                status: order.delivery_status,
                itemType: order?.product?.category,
              },
            ],
          })),
        );
        setPaginationData({
          current_page: data?.meta?.current_page,
          per_page: data?.meta?.per_page,
          total: data?.meta?.total,
        });
      }
    } catch (error: any) {
      const message =
        formateErrorObject(error) || 'An error occurred while fetching data.';

      notify(message, 'error');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const normalizedPath = router.pathname.replace(/\/$/, '');
    const isWebOrders = normalizedPath === '/my-orders';
    const isAppOrders = normalizedPath === '/in-app-orders';

    setActiveTab(isWebOrders ? 'Web Orders' : 'App Orders');

    if (isWebOrders) {
      getAllOrders(page);
    } else if (isAppOrders) {
      getAllInAppOrders(page);
    }
  }, [page, router.pathname, fetchOrders]);

  const onChange: PaginationProps['onChange'] = (pageNumber: number) => {
    setPage(pageNumber);
  };





  return (
    <div className='relative overflow-hidden pb-20'>
      <HeroSection />

      <div className='px-5 sm:px-10  lg:px-24 pt-8 md:pt-14 flex flex-col gap-y-5'>
        {/* <div className='flex md:justify-end mt-10'>
          <span className='flex flex-col md:flex-row gap-4 '>
            <div className='flex gap-x-4'>
              <Button
                size='large'
                onClick={() => setFilterByDate('Most Recent')}
                className={clsx(
                  filterByDate !== 'Most Recent' && 'border-gray-700',
                  'text-fadedWhite border-gray-200'
                )}
              >
                <span className='px-2 '>Most Recent</span>
              </Button>
              <Button
                size='large'
                onClick={() => setFilterByDate('Old Orders')}
                className={clsx(
                  filterByDate !== 'Old Orders' && 'border-gray-700',
                  'text-fadedWhite border-gray-200'
                )}
              >
                <span className='px-2'>Old Orders</span>
              </Button>
            </div>
          </span>
        </div> */}

        <div className='flex justify-between items-center'>
          <div className='flex text-fadedWhite text-sm md:text-xl font-medium '>
            My Orders
          </div>
          <div className='flex gap-x-4 text-fadedWhite text-xl font-medium'>
            <Button
              onClick={() => handleTabSwitch('Web Orders')}
              className={clsx(
                activeTab === 'Web Orders'
                  ? 'border-white'
                  : 'border-dropDownMenuBg',
                'text-white text-xs md:text-base',
              )}
            >
              Web Orders
            </Button>
            <Button
              onClick={() => handleTabSwitch('App Orders')}
              className={clsx(
                activeTab === 'App Orders'
                  ? 'border-white'
                  : 'border-dropDownMenuBg',
                'text-white  text-xs md:text-base',
              )}
            >
              App Orders
            </Button>
          </div>
        </div>
        {/* <Banner /> */}
        <ShouldRender check={activeTab === 'Web Orders'}>
          <div className='flex flex-col gap-8 '>
            {orderData.length > 0 ? (
              orderData.map((order, index) => (
                <MyOrderCard
                  key={`${order?.orderId}-${index}`}
                  data={order}
                  fetchOrders={fetchOrders}
                  setFetchOrders={setFetchOrders}
                />
              ))
            ) : (
              <ShouldRender check={!loading}>
                <div className='flex justify-center items-center w-full h-[40vh]'>
                  <Empty description='No Web Orders Available' />
                </div>
              </ShouldRender>
            )}
          </div>
        </ShouldRender>

        <ShouldRender check={activeTab === 'App Orders'}>
          <div className='flex flex-col gap-8 '>
            {inAppPurchaseData.length > 0 ? (
              inAppPurchaseData.map((order, index) => (
                <MyOrderCard
                  key={`${order?.orderId}-${index}`}
                  data={order}
                  fetchOrders={fetchOrders}
                  setFetchOrders={setFetchOrders}
                  isInAppPurchase={true}
                />
              ))
            ) : (
              <ShouldRender check={!loading}>
                <div className='flex justify-center items-center w-full h-[40vh]'>
                  <Empty description='No App Orders Available' />
                </div>
              </ShouldRender>
            )}
          </div>
        </ShouldRender>

        <ShouldRender check={loading}>
          <div className='flex justify-center py-20'>
            <CustomLoader />
          </div>
        </ShouldRender>

        <ShouldRender check={orderData?.length && !loading}>
          <div className='flex justify-center pt-5'>
            <Pagination
              defaultCurrent={paginationData?.current_page}
              current={page}
              className='text-fadedWhite'
              total={paginationData?.total}
              pageSize={paginationData?.per_page || 0}
              onChange={onChange}
              showSizeChanger={false}
            />
          </div>
        </ShouldRender>
      </div>
    </div>
  );
};

export default MyOrders;
